import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { CLOSING } from "@/data/minka";

export const Closing = () => (
  <section className="relative px-5 py-32 md:px-10 md:py-48" data-testid="closing-section">
    <div className="mx-auto max-w-[1100px] text-left">
      <Reveal>
        <p className="font-serif-i text-3xl leading-snug text-[#E2E0D8] sm:text-4xl lg:text-5xl">{CLOSING}</p>
      </Reveal>
      <Reveal delay={0.15} className="mt-14 flex flex-wrap gap-4">
        <Link to="/film-options" data-testid="closing-options-btn" className="group flex items-center gap-3 rounded-full bg-[#C81D25] px-8 py-4 font-mono-s text-xs uppercase tracking-[0.25em] text-[#E2E0D8] transition-colors duration-300 hover:bg-[#E76F51]">
          Option or purchase MINKA <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </Link>
        <Link to="/author" data-testid="closing-author-btn" className="rounded-full border border-white/25 px-8 py-4 font-mono-s text-xs uppercase tracking-[0.25em] text-[#E2E0D8] transition-colors duration-300 hover:border-[#A8DADC] hover:text-[#A8DADC]">
          Meet the author
        </Link>
      </Reveal>
    </div>
  </section>
);
